import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/Info';
import { API } from '../../conf';

export default function NotifInfo({ alert, onDismiss }) {
    const [showMessage, setShowMessage] = useState(false)

    function dismiss() {
        fetch(API.concat(`/alerts/${alert.num}/dismiss`), {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + sessionStorage.getItem('token') }
        }).then(res => {
            const token = res.headers.get('x-auth-token')
            if (token && token !== sessionStorage.getItem('token') && token !== '') sessionStorage.setItem('token', token)
            if (res.status === 200) onDismiss(alert.num)
        })
    }

    return (
        <Box sx={{
            backgroundColor: 'rgba(20, 123, 255, 0.2)',
            borderRadius: '8px',
            paddingBlock: 1, paddingInline: 2,
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '600px', minWidth: '300px',
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ flex: 1 }}>{alert.title}</Typography>
                <IconButton onClick={() => setShowMessage(s => !s)}><InfoIcon /></IconButton>
                <IconButton size='small' onClick={dismiss}><Close fontSize='small' /></IconButton>
            </Box>
            {showMessage && <Typography variant="body2">{alert.message}</Typography>}
        </Box>
    )
}
